<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
    <div
      class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
    >
      Achtergrondgegevens
    </div>
    <div class="p-2">
      <table class="w-full table-auto">
        <tr v-for="row in backgroundData" :key="row.title">
          <th scope="row" class="text-left">{{ row.title }}</th>
          <td v-if="row.value">{{ row.value }}</td>
          <td v-else class="text-gray-400">Onbekend</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import BaseCard from "./BaseCard";

export default {
  name: "ExternalDataCard",
  extends: BaseCard,
  props: ["acc"],
  computed: {
    lastVerification: function() {
      if (this.acc.verificaties.length === 0) return null;
      const verifications = this.acc.verificaties.map(verification => ({
        ...verification,
        datum: new Date(verification.datum)
      }));
      verifications.sort((v1, v2) => (v1.datum < v2.datum ? 1 : -1));
      const last = verifications[0].datum;
      return `${last.getDate()}-${last.getMonth() + 1}-${last.getFullYear()}`;
    },
    backgroundData: function() {
      return [
        { title: "BAG pand id", value: this.acc["bag_data"]["pand_id"] },
        { title: "BAG bouwjaar", value: this.acc["bag_data"]["bouwjaar"] },
        { title: "Energielabel", value: this.acc["energielabel"] },
        { title: "Laatste check", value: this.lastVerification }
      ];
    }
  }
};
</script>
